const AnalyticsKPICardsSkeleton = () => (
  <div className="kpi-grid">
    {Array.from({ length: 5 }).map((_, i) => (
      <div key={i} className="skeleton-card">
        <div className="skeleton skeleton-card__icon" />
        <div className="skeleton skeleton-card__label" />
        <div className="skeleton skeleton-card__value" />
      </div>
    ))}
  </div>
);

export default AnalyticsKPICardsSkeleton;
